import React from 'react';

import { useTranslation } from '@crehana/i18n';

import { getQueryParam } from '@crehana/utils';

import MembershipBenefits from 'Jsx/CheckoutV4/pages/CheckoutDesktop/components/PurchaseDetail/ProductDetail/MembershipDetail/MembershipBenefits';

const MembershipDetail: React.FC<{ months: string | null }> = ({ months }) => {
  const { t } = useTranslation();
  const isMsLite = getQueryParam('source_detail') === 'Membership Lite';
  const defaultRenovation = isMsLite
    ? t('LITE_BENEFIT', { interpolation: { monthNumber: 6 } })
    : t('PREMIUM_BENEFIT_3', { interpolation: { yearNumber: 1 } });
  const [renovationMessage, setRenovationMessage] =
    React.useState(defaultRenovation);

  React.useEffect(() => {
    const _months = months ? parseInt(months, 10) : 0;

    if (_months && _months !== 12) {
      setRenovationMessage(
        t('PREMIUM_BENEFIT_4', { interpolation: { monthNumber: _months } }),
      );
    }
    // else: default initial value for 'renovationMessage' state.
  }, [months]);
  return (
    <MembershipBenefits
      className="mt-20"
      renovationMessage={renovationMessage}
    />
  );
};

export default MembershipDetail;
